module.exports = __webpack_public_path__ + "static/media/instagram-color-square.0e5ce239.svg";